<script lang="ts">
	import { Button } from 'flowbite-svelte';
	import { push } from '../svelte-spa-router';
</script>

<div class="flex flex-col items-center justify-center min-h-[60vh] text-center">
	<div class="text-8xl font-bold text-gradient-primary mb-4">404</div>
	<h1 class="text-2xl font-semibold text-gray-900 dark:text-white mb-2 after:hidden">
		Page Not Found
	</h1>
	<p class="text-default mb-6 max-w-md">
		The page you're looking for doesn't exist or has been moved.
	</p>
	<Button on:click={() => push('/')}>
		<i class="fa-solid fa-house mr-2"></i>
		Go to the overview
	</Button>
</div>
